module.exports = __webpack_public_path__ + "static/img/fdc-yj.3daad4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/fdc-yj.jpg
// module id = tkYC
// module chunks = 1